<div class="d-flex justify-content-between align-items-center product-list-item">
  <div class="product-list-item-img me-3"
       (click)="isComplex ? onEdit.emit(orderLine) : null">
    <img *ngIf="orderLine.product.image || orderLine.product.type.image"
         [src]="(orderLine.product.image || orderLine.product.type.image) | multiUrlImage: 'original' : ''" alt="">

    <div class="cart-edit-badge-wrap"
         *ngIf="isComplex">
      <div class="cart-edit-badge font-xxs bg-primary"
           [translate]="'common.edit'">
        Edit
      </div>
    </div>

  </div>

  <div class="product-list-item-info product-item-font align-self-center me-3">
    <div class="fw-bold product-name"
         [class.multi-variant]="!orderLine?.variant?.isStandard">
      {{ orderLine.name }}
    </div>

    <div class="multi-variant" *ngIf="!orderLine?.variant?.isStandard">
      <span *ngIf="isComplex">
        {{orderLine?.size?.details?.value}} {{orderLine?.size?.details?.measurement}},
      </span> {{ orderLine.variant.name }}
    </div>

    <div>
      <div class="d-inline-block text-danger font-xs"
           (click)="onRemoveOrderLine.emit(orderLine)"
           [translate]="'cart.deleteCake'">
      </div>
    </div>
  </div>

  <div>
    <ui-mobile-single-counter
      [count]="orderLine.count"
      [step]="orderLine?.size?.details?.pieces ? orderLine.productType.increment || 1 : 1"
      [minCount]="minQuantity(orderLine)"
      [maxCount]="maxQuantity(orderLine)"
      [disableZeroCount]="true"
      [isAllowEnterCounter]="true"
      (onCountUpdated)="orderLine.count = $event; count$.next($event)"
    ></ui-mobile-single-counter>

    <div class="text-center product-item-font mt-2">
      {{ (orderLine.price * orderLine.count) | currencyFormat: currency }}
    </div>
  </div>
</div>

<div class="product-list-item-addons" *ngIf="orderLine?.orderLines && orderLine?.orderLines?.length">
  <div class="product-addons-list">
    <div class="product-addons-list-item d-flex justify-content-between font-md"
         *ngFor="let oLine of orderLine?.orderLines">
      <div class="product-addon-name pe-2" [ngSwitch]="oLine.type">
        <ng-container *ngSwitchCase="CART_LINE_TYPES.PICTURE">
          <div class="underline" [imagePreviewTrigger]="oLine?.details?.url">
            {{oLine.name}}
          </div>
        </ng-container>

        <ng-container *ngSwitchDefault>{{oLine.name}}</ng-container>
      </div>

      <div class="text-end" [ngSwitch]="oLine.type">
        <ng-container *ngSwitchCase="CART_LINE_TYPES.GREETING_CARD">
          +&nbsp;{{ oLine.price | currencyFormat: currency }}
        </ng-container>

        <ng-container *ngSwitchDefault>
          +&nbsp;{{ (oLine.price * orderLine.count) | currencyFormat: currency }}
        </ng-container>
      </div>
    </div>
  </div>
</div>
